export const CLUBS = {
  39: [
    {
      "id": 42,
      "name": "Arsenal",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 66,
      "name": "Aston Villa",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 54,
      "name": "Birmingham",
      "seasons": [
        2010
      ]
    },
    {
      "id": 67,
      "name": "Blackburn",
      "seasons": [
        2010,
        2011
      ]
    },
    {
      "id": 1356,
      "name": "Blackpool",
      "seasons": [
        2010
      ]
    },
    {
      "id": 68,
      "name": "Bolton",
      "seasons": [
        2010,
        2011
      ]
    },
    {
      "id": 35,
      "name": "Bournemouth",
      "seasons": [
        2015,
        2016,
        2017,
        2018,
        2019,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 55,
      "name": "Brentford",
      "seasons": [
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 51,
      "name": "Brighton",
      "seasons": [
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 44,
      "name": "Burnley",
      "seasons": [
        2014,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2023
      ]
    },
    {
      "id": 43,
      "name": "Cardiff",
      "seasons": [
        2013,
        2018
      ]
    },
    {
      "id": 49,
      "name": "Chelsea",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 52,
      "name": "Crystal Palace",
      "seasons": [
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 45,
      "name": "Everton",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 36,
      "name": "Fulham",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2018,
        2020,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 37,
      "name": "Huddersfield",
      "seasons": [
        2017,
        2018
      ]
    },
    {
      "id": 64,
      "name": "Hull City",
      "seasons": [
        2013,
        2014,
        2016
      ]
    },
    {
      "id": 57,
      "name": "Ipswich",
      "seasons": [
        2024
      ]
    },
    {
      "id": 63,
      "name": "Leeds",
      "seasons": [
        2020,
        2021,
        2022
      ]
    },
    {
      "id": 46,
      "name": "Leicester",
      "seasons": [
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2024
      ]
    },
    {
      "id": 40,
      "name": "Liverpool",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 1359,
      "name": "Luton",
      "seasons": [
        2023
      ]
    },
    {
      "id": 50,
      "name": "Manchester City",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 33,
      "name": "Manchester United",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 70,
      "name": "Middlesbrough",
      "seasons": [
        2016
      ]
    },
    {
      "id": 34,
      "name": "Newcastle",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 71,
      "name": "Norwich",
      "seasons": [
        2011,
        2012,
        2013,
        2015,
        2019,
        2021
      ]
    },
    {
      "id": 65,
      "name": "Nottingham Forest",
      "seasons": [
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 72,
      "name": "QPR",
      "seasons": [
        2011,
        2012,
        2014
      ]
    },
    {
      "id": 53,
      "name": "Reading",
      "seasons": [
        2012
      ]
    },
    {
      "id": 62,
      "name": "Sheffield Utd",
      "seasons": [
        2019,
        2020,
        2023
      ]
    },
    {
      "id": 41,
      "name": "Southampton",
      "seasons": [
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2024
      ]
    },
    {
      "id": 75,
      "name": "Stoke City",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017
      ]
    },
    {
      "id": 746,
      "name": "Sunderland",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016
      ]
    },
    {
      "id": 76,
      "name": "Swansea",
      "seasons": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017
      ]
    },
    {
      "id": 47,
      "name": "Tottenham",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 38,
      "name": "Watford",
      "seasons": [
        2015,
        2016,
        2017,
        2018,
        2019,
        2021
      ]
    },
    {
      "id": 60,
      "name": "West Brom",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2020
      ]
    },
    {
      "id": 48,
      "name": "West Ham",
      "seasons": [
        2010,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 61,
      "name": "Wigan",
      "seasons": [
        2010,
        2011,
        2012
      ]
    },
    {
      "id": 39,
      "name": "Wolves",
      "seasons": [
        2010,
        2011,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    }
  ],
  135: [
    {
      "id": 489,
      "name": "AC Milan",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 497,
      "name": "AS Roma",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 499,
      "name": "Atalanta",
      "seasons": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 508,
      "name": "Bari",
      "seasons": [
        2010
      ]
    },
    {
      "id": 506,
      "name": "Benevento",
      "seasons": [
        2017,
        2020
      ]
    },
    {
      "id": 500,
      "name": "Bologna",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 518,
      "name": "Brescia",
      "seasons": [
        2010,
        2019
      ]
    },
    {
      "id": 490,
      "name": "Cagliari",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2023,
        2024
      ]
    },
    {
      "id": 519,
      "name": "Carpi",
      "seasons": [
        2015
      ]
    },
    {
      "id": 1580,
      "name": "Catania",
      "seasons": [
        2010,
        2011,
        2012,
        2013
      ]
    },
    {
      "id": 509,
      "name": "Cesena",
      "seasons": [
        2010,
        2011,
        2014
      ]
    },
    {
      "id": 491,
      "name": "Chievo",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018
      ]
    },
    {
      "id": 895,
      "name": "Como",
      "seasons": [
        2024
      ]
    },
    {
      "id": 520,
      "name": "Cremonese",
      "seasons": [
        2022
      ]
    },
    {
      "id": 501,
      "name": "Crotone",
      "seasons": [
        2016,
        2017,
        2020
      ]
    },
    {
      "id": 511,
      "name": "Empoli",
      "seasons": [
        2014,
        2015,
        2016,
        2018,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 502,
      "name": "Fiorentina",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 512,
      "name": "Frosinone",
      "seasons": [
        2015,
        2018,
        2023
      ]
    },
    {
      "id": 495,
      "name": "Genoa",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2023,
        2024
      ]
    },
    {
      "id": 505,
      "name": "Inter",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 496,
      "name": "Juventus",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 487,
      "name": "Lazio",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 867,
      "name": "Lecce",
      "seasons": [
        2010,
        2011,
        2019,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 868,
      "name": "Livorno",
      "seasons": [
        2013
      ]
    },
    {
      "id": 1579,
      "name": "Monza",
      "seasons": [
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 492,
      "name": "Napoli",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 513,
      "name": "Novara",
      "seasons": [
        2011
      ]
    },
    {
      "id": 522,
      "name": "Palermo",
      "seasons": [
        2010,
        2011,
        2012,
        2014,
        2015,
        2016
      ]
    },
    {
      "id": 523,
      "name": "Parma",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2018,
        2019,
        2020,
        2024
      ]
    },
    {
      "id": 525,
      "name": "Pescara",
      "seasons": [
        2012,
        2016
      ]
    },
    {
      "id": 1583,
      "name": "Robur Siena",
      "seasons": [
        2011,
        2012
      ]
    },
    {
      "id": 514,
      "name": "Salernitana",
      "seasons": [
        2021,
        2022,
        2023
      ]
    },
    {
      "id": 498,
      "name": "Sampdoria",
      "seasons": [
        2010,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022
      ]
    },
    {
      "id": 488,
      "name": "Sassuolo",
      "seasons": [
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023
      ]
    },
    {
      "id": 493,
      "name": "Spal",
      "seasons": [
        2017,
        2018,
        2019
      ]
    },
    {
      "id": 515,
      "name": "Spezia",
      "seasons": [
        2020,
        2021,
        2022
      ]
    },
    {
      "id": 503,
      "name": "Torino",
      "seasons": [
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 494,
      "name": "Udinese",
      "seasons": [
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    },
    {
      "id": 517,
      "name": "Venezia",
      "seasons": [
        2021,
        2024
      ]
    },
    {
      "id": 504,
      "name": "Verona",
      "seasons": [
        2013,
        2014,
        2015,
        2017,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024
      ]
    }
  ]
};
